<template>
  <div class="uk-grid" uk-grid>
    <div class="uk-width-1-1" v-if="banners && banners.length">
      <banners :banners="banners"></banners>
    </div>
    <div class="uk-width-1-1" v-if="initialLoad">
      <div class="uk-flex uk-flex-center uk-flex-middle uk-padding-large">
        <div data-uk-spinner="ratio: 1.5"></div>
      </div>
    </div>
    <template v-else>
      <div class="uk-width-1-1" v-if="Object.keys(filters).length">
        <h4 class="uk-margin-small">Fahrzeugsuche</h4>
        <component :is="searchLayout" :filters="filters" ref="search" id="search" @search="onSearch" />
      </div>
      <div class="uk-width-1-1" v-if="meta && meta.pagination.total > 0">
        <div class="uk-grid uk-flex uk-flex-middle uk-flex-between" data-uk-grid>
          <div>
            <h5 class="uk-margin-small">{{ meta.pagination.total }} Fahrzeug(e) gefunden</h5>
          </div>
          <div class="uk-width-auto@m" v-if="meta && meta.pagination.total_pages > 1">
            <pagination :pagination="meta.pagination" @pagination:switched="onPaginationSwitch"></pagination>
          </div>
          <div class="uk-width-medium@m sort">
            <div class="uk-flex uk-flex-middle">
              <div class="uk-width-medium@m sort">
                <sort :options="sortOptions" @change="onSortChange" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-width-1-1" v-if="vehicles.length">
        <div class="b2b-vehicle-list">
          <vehicle-card :vehicle="vehicle" v-for="vehicle in vehicles" :key="vehicle.id"></vehicle-card>
        </div>
      </div>
      <div class="uk-width-1-1" v-else>
        <div class="uk-grid uk-flex-center uk-text-center" uk-grid>
          <div class="uk-width-3-4@m uk-width-1-1">
            <img class="uk-text-primary uk-margin-top" width="100" src="/img/vehicle-sale.svg" data-uk-svg />
            <div class="uk-text-large uk-text-bold uk-margin">
              Zurzeit keine Fahrzeuge vorhanden
            </div>
          </div>
        </div>
      </div>
      <div class="uk-width-1-1" v-if="meta && meta.pagination.total_pages > 1">
        <pagination :pagination="meta.pagination" @pagination:switched="onPaginationSwitch"></pagination>
      </div>
    </template>
  </div>
</template>
<script>
import VehicleService from '@/services/vehicle.service'
import VehicleCard from '@/components/vehicles/VehicleCard'
import Pagination from '@/components/Pagination'
import Sort from '@/components/vehicles/Sort.vue'
import Banners from '@/components/Banners'
const SearchDefault = () => import('@/components/vehicles/Search')
const SearchBruening = () => import('@/components/vehicles/SearchBruening')

import _ from 'lodash'
import { mapGetters } from 'vuex'
export default {
  components: {
    VehicleCard,
    Pagination,
    SearchDefault,
    SearchBruening,
    Banners,
    Sort
  },
  data() {
    return {
      vehicles: [],
      meta: null,
      filters: {},
      initialLoad: true,
      loading: false,
      sortOptions: [
        {
          label: 'Standard-Sortierung',
          value: null
        },
        {
          label: 'Preis aufsteigend',
          value: 'salepricemerchant|asc'
        },
        {
          label: 'Preis absteigend',
          value: 'salepricemerchant|desc'
        },
        {
          label: 'Kilometer aufsteigend',
          value: 'truemilage|asc'
        },
        {
          label: 'Kilometer absteigend',
          value: 'truemilage|desc'
        },
        {
          label: 'Erstzulassung aufsteigend',
          value: 'firstregdate|asc'
        },
        {
          label: 'Erstzulassung absteigend',
          value: 'firstregdate|desc'
        },
        {
          label: 'Leistung aufsteigend',
          value: 'kw|asc'
        },
        {
          label: 'Leistung absteigend',
          value: 'kw|desc'
        }
      ]
    }
  },
  mounted() {
    this.getFilters()
    this.getVehicles()
  },
  computed: {
    ...mapGetters(['banners', 'tenant']),
    searchLayout() {
      if (this.tenant && this.tenant.knumber === 'K10149') {
        return 'SearchBruening'
      }
      return 'SearchDefault'
    },
  },
  methods: {
    getVehicles(params = this.$route.query) {
      this.loading = true
      VehicleService.getList({ ...params }).then(response => {
        this.vehicles = response.data.vehicles
        this.meta = response.data.meta
        const el = document.querySelector('#search')
        if (el) {
          const y = el.getBoundingClientRect().top + window.pageYOffset - 150
          window.scrollTo({ top: y, behavior: 'smooth' })
        }
        setTimeout(() => {
          this.initialLoad = false
        }, 1000)
      })
      this.loading = false
      //this.getFilters()
    },
    getFilters(query = this.$route.query) {
      VehicleService.getFilters(query).then(response => {
        this.filters = response.data
      })
    },
    onSearch(params) {
      this.addParamsToLocation({ ...params })
      this.getVehicles(params)
    },
    onPaginationSwitch(page) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const currentParams = Object.fromEntries(urlSearchParams.entries());
      const params = Object.assign({}, {...currentParams}, { page })
      this.onSearch(params)
    },
    onSortChange(data) {
      _.merge(this.$refs.search.selected, {
        sortBy: data
      })
      this.$refs.search.activateFilter()
    },
    addParamsToLocation(params) {
      history.pushState(
        {},
        null,
        this.$route.path +
        '?' +
        Object.keys(params)
          .map(key => {
            return (
              encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
            )
          })
          .join('&')
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.v-select {
  background: #fff;
  border-radius: 4px;
}
</style>
